import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export type Standard = {
  name: string;
  ref: string;
  description: string;
};

/** Map framework prefix to subtle color classes */
function getFrameworkColors(name: string): string {
  const lower = name.toLowerCase();
  if (lower.includes("nist")) return "bg-blue-50 text-blue-700 ring-blue-200";
  if (lower.includes("iso")) return "bg-purple-50 text-purple-700 ring-purple-200";
  if (lower.includes("oecd")) return "bg-teal-50 text-teal-700 ring-teal-200";
  if (lower.includes("fatf")) return "bg-amber-50 text-amber-700 ring-amber-200";
  return "bg-muted text-muted-foreground ring-border";
}

export function StandardsPills({ standards }: { standards?: Standard[] }) {
  if (!Array.isArray(standards) || standards.length === 0) return null;

  return (
    <TooltipProvider delayDuration={200}>
      <div className="mt-1">
        <div className="flex flex-wrap gap-2">
          {standards.map((std) => (
            <Tooltip key={`${std.name}-${std.ref}`}>
              <TooltipTrigger asChild>
                <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset cursor-default ${getFrameworkColors(std.name)}`}>
                  {std.name}
                </span>
              </TooltipTrigger>
              <TooltipContent
                side="right"
                align="start"
                collisionPadding={16}
                className="max-w-xs text-sm z-[1000]"
              >
                <p className="font-semibold">{std.ref}</p>
                <p className="mt-1 text-muted-foreground">{std.description}</p>
              </TooltipContent>
            </Tooltip>
          ))}
        </div>
      </div>
    </TooltipProvider>
  );
}
